<template>
  <div style="display: flex; justify-content: center;">
    <div class="sign-field" :class="[bordered ? 'bordered': '']">
      <div v-if="image" class="sign-image" :style="{backgroundImage: image? `url(${image})`: ''}" @click="handleClickImage"></div>
<!--      <img v-if="image" :src="image" style="border: 0; height:80px;" @click="handleClickImage"/>-->
      <div v-else @click.stop="handleClick" style="width:100%; height: 100%; min-height:80px; min-width: 120px; display: flex; justify-content: center; align-items: center; color: #3c3c3c">
        <template v-if="lang === 'ko'">클릭하여<br>서명하기</template>
        <template v-else>Click to sign</template>
      </div>

      <popup-sign-field v-model="showPopup" :lang="lang" :image="image" :readonly="readonly" @save="handleSave" @update="handleUpdate" @delete="handleDelete"/>
    </div>
  </div>
</template>

<script>
import PopupSignField from '@/popup/PopupSignField'
export default {
  name: 'SignField',
  components: {PopupSignField},
  props: {
    value: String,
    readonly: Boolean,
    // 테두리를 표시할지 여부
    bordered: {
      type: Boolean,
      default: true
    },
    lang: {
      type: String,
      default: 'ko'
    }
  },
  data () {
    return {
      image: this.value,
      showPopup: false,
      passHistoryBack: false,
    }
  },
  computed:{
    projectId () {
      return this.$route.params.proj_id
    },
  },
  watch: {
    value (value) {
      this.image = value
    },
    image (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    moveMySignUpdate () {
      if (this.projectId) {
        window.location.href = `/project/${this.projectId}/mypage/sign-update`
      } else {
        window.location.href = '/mypage/sign-update'
      }
    },
    handleSave (value) {
      this.image = value
    },
    handleDelete () {
      if (confirm("삭제하시겠습니까?")) {
        this.image = ''
      }
    },
    handleClick () {
      this.showPopup = true
    },
    handleUpdate(imgSrc) {
      if (imgSrc === false) {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "알림",
            message: '등록된 서명이 없습니다.',
            useConfirm: true,
            confirmBtn: "개인서명관리 페이지로 이동",
            confirmFunction: () => this.moveMySignUpdate(),
          },
        });
        window.dispatchEvent(customAlert);
      } else {
        this.image = imgSrc;
      }
    },
    handleClickImage () {
      this.showPopup = true
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-field {
  display: grid;

  width: 100%;
  height: 100%;

  min-width: 120px;
  max-width:250px;
  min-height: 80px;


  img {
    width: 100%;
    height: 100%;

    display: inline-block;
    content: "";
    border-radius: 6px;
  }
  .sign-image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  &.bordered {
    border: solid 1px #cdcdcd;
    border-radius: 6px;
  }
}
</style>
